import { MdDoubleArrow } from "react-icons/md";

String.prototype.persianCurrency = function() {
    const formatter = new Intl.NumberFormat('fa-IR', {
        // style: 'currency',
        currency: 'IRR',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    return formatter.format(this);
};

String.prototype.toHighlightedText = function(highlight) {
    const parts = this.split(new RegExp(`(${highlight})`, 'gi'));
    return parts.map((part, i) => (
        <>
            {part.toLowerCase() === highlight 
            ? <b key={i} style={{backgroundColor: 'yellow'}}>{part}</b>
            : part}
        </>
    ));
};